import Vue from "vue";
import Axios from "axios";
import { stringify } from "qs";

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
Axios.defaults.baseURL = "/api/";
Axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
Axios.defaults.paramsSerializer = (params) => {
  return stringify(params, { encodeValuesOnly: true });
};
window.axios = Axios;

// Bind Axios to Vue.
Vue.$http = Axios;
Object.defineProperty(Vue.prototype, "$http", {
  get() {
    return Axios;
  },
});

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  Axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
  console.error(
    "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
  );
}

Axios.interceptors.response.use(
  function (response) {
    // Don't change anything
    return response;
  },
  function (error) {
    if (error.response) {
      switch (error.response.status) {
        // CSRF Token mismatch case
        case 419:
          location.reload();
          break;
        // Unauthorized
        case 401:
          location.href = "/login";
          break;
      }
    }

    return Promise.reject(error);
  }
);

/**
 * Next we will register the JWT Token as a authorization header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let authToken = document.head.querySelector('meta[name="auth-token"]');

if (authToken && authToken.content) {
  Axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${authToken.content}`;
}
